jQuery(document).ready(function($) {
	
	if($('#graduateListTable').length) {
		
		var paging = $('#graduateListTable').data('paging');
		var info = $('#graduateListTable').data('info');
		var program = $('#graduateListTable').data('program');
		
		if (program == 'ug') {
			
			$('#graduateListTable').DataTable({
				paging: paging,
				info: info,
				responsive: true,
				order: [[ 1, "asc" ]],
				lengthMenu: [[25, 50, 100, -1], [25, 50, 100, "All"]],
				dom: '<"table-top"lf>t<"table-bottom"ip>',
				orderClasses: false,
				columnDefs: [
					{ targets: 'no-sort', orderable: false },
					{ responsivePriority: 1, targets: 0 },
					{ responsivePriority: 2, targets: 1 },
					{ responsivePriority: 3, targets: 4 },
					{ responsivePriority: 4, targets: 2 },
					{ responsivePriority: 5, targets: 3 },
				],
				initComplete: function () {
					this.api().columns([4]).every( function () {
						var column = this;
						var select = $('<select id="degreeFilter" style="width: 100%"><option value="">Show all</option></select>')
							.appendTo( '#graduateListTable_filter' )
							.wrap( '<div class="select-filter"></div>' )
							.before('<label for="degreeFilter">Filter by Degree:</label>')
							.on( 'change', function () {
								var val = $.fn.dataTable.util.escapeRegex(
									$(this).val()
								);
	
								column
									.search( val ? '^'+val+'$' : '', true, false )
									.draw();
							} );
	
						column.data().unique().sort().each( function ( d, j ) {
							select.append( '<option value="'+d+'">'+d+'</option>' )
						} );
					} );
					$('#graduateListTable_wrapper').find('select').select2({
						minimumResultsForSearch: Infinity
					});
				},
				language: {
					"lengthMenu": "Show _MENU_ names",
					"info": "Showing _START_ to _END_ of _TOTAL_ names",
				}
			});
			
		}
		
		if (program == 'imedia' || program == 'mhe') {
			
			$('#graduateListTable').DataTable({
				paging: paging,
				info: info,
				responsive: true,
				order: [[ 1, "asc" ]],
				lengthMenu: [[25, 50, 100, -1], [25, 50, 100, "All"]],
				dom: '<"table-top"lf>t<"table-bottom"ip>',
				orderClasses: false,
				columnDefs: [
					{ targets: 'no-sort', orderable: false },
					{ responsivePriority: 1, targets: 0 },
					{ responsivePriority: 2, targets: 1 },
					{ responsivePriority: 3, targets: 2 },
				],
				initComplete: function () {
					$('#graduateListTable_wrapper').find('select').select2({
						minimumResultsForSearch: Infinity
					});
				},
				language: {
					"lengthMenu": "Show _MENU_ names",
					"info": "Showing _START_ to _END_ of _TOTAL_ names",
				}
			});
			
		}
		
		if (program == 'lsb') {
			
			$('#graduateListTable').DataTable({
				paging: paging,
				info: info,
				responsive: true,
				order: [[ 1, "asc" ]],
				lengthMenu: [[25, 50, 100, -1], [25, 50, 100, "All"]],
				dom: '<"table-top"lf>t<"table-bottom"ip>',
				orderClasses: false,
				columnDefs: [
					{ targets: 'no-sort', orderable: false },
					{ responsivePriority: 1, targets: 0 },
					{ responsivePriority: 2, targets: 1 },
					{ responsivePriority: 3, targets: 2 },
				],
				initComplete: function () {
					this.api().columns([2]).every( function () {
						var column = this;
						var select = $('<select id="degreeFilter" style="width: 100%"><option value="">Show all</option></select>')
							.appendTo( '#graduateListTable_filter' )
							.wrap( '<div class="select-filter"></div>' )
							.before('<label for="degreeFilter">Filter by Degree:</label>')
							.on( 'change', function () {
								var val = $.fn.dataTable.util.escapeRegex(
									$(this).val()
								);
	
								column
									.search( val ? '^'+val+'$' : '', true, false )
									.draw();
							} );
	
						column.data().unique().sort().each( function ( d, j ) {
							select.append( '<option value="'+d+'">'+d+'</option>' )
						} );
					} );
					$('#graduateListTable_wrapper').find('select').select2({
						minimumResultsForSearch: Infinity
					});
				},
				language: {
					"lengthMenu": "Show _MENU_ names",
					"info": "Showing _START_ to _END_ of _TOTAL_ names",
				}
			});
			
		}
		
	}
});